module.exports = __webpack_public_path__ + "img/facebook-post.345e9a45.png";